<template>
  <div class="order-add-page">
    <el-card class="form-card" shadow="never">
      <div class="form-section">
        <div class="form-title">客户信息</div>

        <div v-if="leadId" class="lead-tip">
          <i class="el-icon-link lead-tip-icon"></i>
          <span>关联线索 #{{ leadId }}，成交后将自动回写线索状态</span>
        </div>

        <el-form ref="form" :model="form" :rules="rules" label-width="100px" size="medium">
          <el-form-item v-if="dealLeads.length" label="已成交学员">
            <el-select
              v-model="selectedLead"
              placeholder="选择已成交线索自动带入量账号等"
              style="width: 100%"
              clearable
              filterable
              @change="onSelectDealLead"
            >
              <el-option
                v-for="l in dealLeads"
                :key="l.id"
                :value="l.id"
                :label="`${l.liang_account}${l.liang_name ? '（' + l.liang_name + '）' : ''}`"
              />
            </el-select>
            <div class="form-hint">选中后自动带入量账号（微信号）/客户信息，可修改</div>
          </el-form-item>
          <el-form-item label="客户姓名" prop="customer_name">
            <el-input v-model="form.customer_name" placeholder="最多 50 字" :maxlength="50" />
          </el-form-item>
          <el-form-item label="客户手机号" prop="customer_phone">
            <el-input v-model="form.customer_phone" placeholder="11 位手机号" :maxlength="11" />
          </el-form-item>
          <el-form-item label="身份证号">
            <el-input v-model="form.id_card" placeholder="选填，15 或 18 位" :maxlength="18" />
          </el-form-item>
          <el-form-item label="量账号" prop="liang_account">
            <el-input v-model="form.liang_account" placeholder="抖音号 / 微信号等" :maxlength="100" />
          </el-form-item>
          <el-form-item v-if="isCompany" label="归属销售" prop="staff_id">
            <el-select v-model="form.staff_id" placeholder="请选择销售战队员工" style="width: 100%">
              <el-option v-for="s in salesStaffs" :key="s.id" :label="s.name" :value="s.id" />
            </el-select>
          </el-form-item>
        </el-form>
      </div>

      <div class="form-section">
        <div class="form-title">订单信息</div>

        <el-form ref="form2" :model="form" :rules="rules2" label-width="100px" size="medium">
          <el-form-item label="商品" prop="product_id">
            <el-select v-model="form.product_id" placeholder="请选择商品" style="width: 100%" @change="onProductChange">
              <el-option v-for="p in products" :key="p.id" :label="p.name" :value="p.id">
                <span style="float: left">{{ p.name }}</span>
                <span style="float: right; color: #E8930C; font-size: 12px">¥{{ p.price }}</span>
              </el-option>
            </el-select>
            <div v-if="curProduct" class="form-hint">
              商品名：{{ curProduct.name }} · 原价 ¥{{ curProduct.original_price }} · 售价 ¥{{ curProduct.price }}
            </div>
          </el-form-item>
          <el-form-item label="售价（元）" prop="price">
            <el-input v-model="form.price" placeholder="0.00" />
            <div v-if="priceRangeText" class="form-hint">可售区间：{{ priceRangeText }}</div>
            <div v-if="priceError" class="form-hint form-hint-err">{{ priceError }}</div>
          </el-form-item>
          <el-form-item label="收款平台" prop="paytype_id">
            <el-select v-model="form.paytype_id" placeholder="请选择收款平台" style="width: 100%" @change="onPaytypeChange">
              <el-option v-for="pt in paytypes" :key="pt.id" :label="pt.name" :value="pt.id">
                <span style="float: left">{{ pt.name }}</span>
                <span style="float: right; color: #8A94AD; font-size: 12px">核算比例 {{ pt.rate }}</span>
              </el-option>
            </el-select>
            <div v-if="curPaytype" class="form-hint">
              业绩按 {{ curPaytype.rate }} 核算：约 ¥{{ form.price ? (parseFloat(form.price) * parseFloat(curPaytype.rate)).toFixed(2) : '—' }}
            </div>
          </el-form-item>
          <el-form-item label="所在地区">
            <div class="area-row">
              <el-select v-model="form.province" placeholder="省份" style="width: 160px" @change="onProvinceChange">
                <el-option v-for="p in provinceList" :key="p" :label="p" :value="p" />
              </el-select>
              <el-select v-model="form.city" placeholder="城市" style="width: 160px" :disabled="!form.province">
                <el-option v-for="c in cityList" :key="c" :label="c" :value="c" />
              </el-select>
              <el-input v-model="form.district" placeholder="区县" style="width: 160px" :maxlength="30" />
            </div>
          </el-form-item>
          <el-form-item label="订单备注">
            <el-input v-model="form.remark" type="textarea" :rows="3" placeholder="选填，最多 500 字" :maxlength="500" />
          </el-form-item>
        </el-form>
      </div>

      <div class="form-section">
        <div class="form-title">首次收款信息</div>

        <el-form ref="form3" :model="form" :rules="rules3" label-width="100px" size="medium">
          <el-form-item label="是否已收款">
            <el-radio-group v-model="form.is_paid">
              <el-radio :label="1">已收款</el-radio>
              <el-radio :label="0">未收款</el-radio>
            </el-radio-group>
          </el-form-item>

          <template v-if="form.is_paid === 1">
            <el-form-item label="收款金额" prop="amount">
              <el-input v-model="form.amount" placeholder="0.00" @input="onAmountInput" />
            </el-form-item>
            <el-form-item label="收款时间">
              <el-date-picker v-model="form.paytime" type="date" value-format="yyyy-MM-dd" placeholder="选择收款日期" style="width: 100%" />
            </el-form-item>
            <el-form-item label="收款凭证">
              <el-upload
                class="voucher-uploader"
                action="/api/upload/index"
                name="file"
                :headers="uploadHeaders"
                :show-file-list="false"
                :on-success="onVoucherSuccess"
                :on-error="() => $message.error('凭证上传失败')"
                accept="image/*"
              >
                <img v-if="form.voucher" :src="form.voucher" class="voucher-preview" />
                <i v-else class="el-icon-plus voucher-uploader-icon"></i>
              </el-upload>
            </el-form-item>
            <el-form-item label="第三方单号">
              <el-input v-model="form.transaction_id" placeholder="选填" :maxlength="64" />
            </el-form-item>
            <el-form-item label="收款备注">
              <el-input v-model="form.bill_remark" placeholder="选填" :maxlength="200" />
            </el-form-item>
          </template>
        </el-form>
      </div>

      <div class="form-actions">
        <el-button @click="$router.back()">取 消</el-button>
        <el-button type="primary" :loading="loading" @click="doSubmit">提交订单</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { orderAdd, orderDealLeads } from '@/api/order'
import { productList, paytypeList } from '@/api/base'
import { unitList, staffList } from '@/api/org'

// 省市区数据（简化版主要省份）
const PROVINCES = [
  '北京', '天津', '上海', '重庆', '河北', '山西', '辽宁', '吉林', '黑龙江',
  '江苏', '浙江', '安徽', '福建', '江西', '山东', '河南', '湖北', '湖南',
  '广东', '广西', '海南', '四川', '贵州', '云南', '西藏', '陕西', '甘肃',
  '青海', '宁夏', '新疆', '内蒙古', '台湾', '香港', '澳门'
]

const CITIES = {
  '北京': ['东城区', '西城区', '朝阳区', '海淀区', '丰台区', '石景山区', '通州区', '顺义区', '大兴区', '昌平区'],
  '上海': ['黄浦区', '徐汇区', '长宁区', '静安区', '普陀区', '虹口区', '杨浦区', '浦东新区', '闵行区', '宝山区'],
  '广东': ['广州', '深圳', '珠海', '汕头', '佛山', '韶关', '湛江', '肇庆', '江门', '茂名', '惠州', '梅州', '汕尾', '河源', '阳江', '清远', '东莞', '中山', '潮州', '揭阳', '云浮'],
  '浙江': ['杭州', '宁波', '温州', '嘉兴', '湖州', '绍兴', '金华', '衢州', '舟山', '台州', '丽水'],
  '江苏': ['南京', '无锡', '徐州', '常州', '苏州', '南通', '连云港', '淮安', '盐城', '扬州', '镇江', '泰州', '宿迁'],
  '四川': ['成都', '自贡', '攀枝花', '泸州', '德阳', '绵阳', '广元', '遂宁', '内江', '乐山', '南充', '眉山', '宜宾', '广安', '达州', '雅安', '巴中', '资阳'],
  '湖北': ['武汉', '黄石', '十堰', '宜昌', '襄阳', '鄂州', '荆门', '孝感', '荆州', '黄冈', '咸宁', '随州'],
  '湖南': ['长沙', '株洲', '湘潭', '衡阳', '邵阳', '岳阳', '常德', '张家界', '益阳', '郴州', '永州', '怀化', '娄底'],
  '福建': ['福州', '厦门', '莆田', '三明', '泉州', '漳州', '南平', '龙岩', '宁德'],
  '山东': ['济南', '青岛', '淄博', '枣庄', '东营', '烟台', '潍坊', '济宁', '泰安', '威海', '日照', '临沂', '德州', '聊城', '滨州', '菏泽'],
  '河南': ['郑州', '开封', '洛阳', '平顶山', '安阳', '鹤壁', '新乡', '焦作', '濮阳', '许昌', '漯河', '三门峡', '南阳', '商丘', '信阳', '周口', '驻马店'],
  '河北': ['石家庄', '唐山', '秦皇岛', '邯郸', '邢台', '保定', '张家口', '承德', '沧州', '廊坊', '衡水'],
  '安徽': ['合肥', '芜湖', '蚌埠', '淮南', '马鞍山', '淮北', '铜陵', '安庆', '黄山', '滁州', '阜阳', '宿州', '六安', '亳州', '池州', '宣城'],
  '陕西': ['西安', '铜川', '宝鸡', '咸阳', '渭南', '延安', '汉中', '榆林', '安康', '商洛'],
  '辽宁': ['沈阳', '大连', '鞍山', '抚顺', '本溪', '丹东', '锦州', '营口', '阜新', '辽阳', '盘锦', '铁岭', '朝阳', '葫芦岛'],
  '江西': ['南昌', '景德镇', '萍乡', '九江', '新余', '鹰潭', '赣州', '吉安', '宜春', '抚州', '上饶'],
  '广西': ['南宁', '柳州', '桂林', '梧州', '北海', '防城港', '钦州', '贵港', '玉林', '百色', '贺州', '河池', '来宾', '崇左'],
  '其他': ['其他']
}

export default {
  name: 'OrderAdd',
  data() {
    return {
      leadId: 0,
      form: {
        customer_name: '',
        customer_phone: '',
        id_card: '',
        liang_account: '',
        product_id: null,
        price: '',
        paytype_id: null,
        province: '',
        city: '',
        district: '',
        remark: '',
        staff_id: null,
        // 首次收款
        is_paid: 0,
        amount: '',
        paytime: '',
        voucher: '',
        transaction_id: '',
        bill_remark: ''
      },
      rules: {
        customer_name: [
          { required: true, message: '请填写客户姓名', trigger: 'blur' },
          { max: 50, message: '最多 50 字', trigger: 'blur' }
        ],
        customer_phone: [
          { required: true, message: '请填写客户手机号', trigger: 'blur' },
          { pattern: /^1\d{10}$/, message: '手机号格式不正确', trigger: 'blur' }
        ],
        liang_account: [
          { required: true, message: '请填写量账号', trigger: 'blur' },
          { max: 100, message: '最多 100 字', trigger: 'blur' }
        ],
        staff_id: [
          { required: true, message: '请选择归属销售', trigger: 'change' }
        ]
      },
      rules2: {
        product_id: [
          { required: true, message: '请选择商品', trigger: 'change' }
        ],
        price: [
          { required: true, message: '请填写售价', trigger: 'blur' }
        ],
        paytype_id: [
          { required: true, message: '请选择收款平台', trigger: 'change' }
        ]
      },
      rules3: {
        amount: [
          { validator: (r, v, cb) => { if (this.form.is_paid === 1 && !(parseFloat(v) > 0)) cb(new Error('已收款请填写收款金额')); else cb() }, trigger: 'blur' }
        ]
      },
      products: [],
      paytypes: [],
      salesStaffs: [],
      dealLeads: [],
      selectedLead: null,
      loading: false
    }
  },
  computed: {
    ...mapState(['user']),
    isCompany() {
      return !!(this.user && this.user.type === 'company')
    },
    uploadHeaders() {
      const token = this.$store.state.token || localStorage.getItem('crm_token') || ''
      return { Token: token }
    },
    curProduct() {
      return this.products.find(p => p.id === this.form.product_id) || null
    },
    curPaytype() {
      return this.paytypes.find(pt => pt.id === this.form.paytype_id) || null
    },
    priceRangeText() {
      const p = this.curProduct
      if (!p) return ''
      return `¥${p.min_price} ~ ${p.max_price > 0 ? '¥' + p.max_price : '不限'}`
    },
    priceError() {
      const p = this.curProduct
      if (!p || this.form.price === '') return ''
      const price = parseFloat(this.form.price)
      if (!(price > 0)) return '售价须大于 0'
      if (price < parseFloat(p.min_price)) return `售价不能低于 ¥${p.min_price}`
      if (parseFloat(p.max_price) > 0 && price > parseFloat(p.max_price)) return `售价不能高于 ¥${p.max_price}`
      return ''
    },
    provinceList() {
      return PROVINCES
    },
    cityList() {
      return CITIES[this.form.province] || ['其他']
    }
  },
  created() {
    // 从 query 获取关联线索参数
    this.leadId = parseInt(this.$route.query.lead_id) || 0
    if (this.$route.query.liang_account) {
      this.form.liang_account = this.$route.query.liang_account
    }
    this.loadProducts()
    this.loadPaytypes()
    this.loadDealLeads()
    if (this.isCompany) this.loadSalesStaffs()
  },
  methods: {
    loadDealLeads() {
      orderDealLeads()
        .then(data => { this.dealLeads = data.list || [] })
        .catch(() => { this.dealLeads = [] })
    },
    /* 选择已成交学员：带入量账号（微信号）与客户信息，可改 */
    onSelectDealLead(leadId) {
      const l = this.dealLeads.find(x => parseInt(x.id) === parseInt(leadId))
      if (!l) {
        this.selectedLead = null
        return
      }
      this.form.liang_account = l.liang_account || ''
      if (!this.form.customer_name) this.form.customer_name = l.customer_name || l.liang_name || ''
      if (!this.form.customer_phone) this.form.customer_phone = l.customer_phone || ''
    },
    loadProducts() {
      productList({ status: 1 })
        .then(data => { this.products = data.list || [] })
        .catch(() => {})
    },
    loadPaytypes() {
      paytypeList({})
        .then(data => { this.paytypes = data.list || [] })
        .catch(() => {})
    },
    loadSalesStaffs() {
      unitList()
        .then(du => {
          const saleUnitIds = (du.list || []).filter(u => parseInt(u.type) === 2).map(u => parseInt(u.id))
          return staffList({}).then(ds => ({ ds, saleUnitIds }))
        })
        .then(({ ds, saleUnitIds }) => {
          this.salesStaffs = (ds.list || []).filter(s => saleUnitIds.indexOf(parseInt(s.unit_id)) > -1 && parseInt(s.status) === 1)
        })
        .catch(() => {})
    },
    onProductChange() {
      const p = this.curProduct
      if (p) {
        this.form.price = String(p.price)
        // 同步收款金额默认值
        if (this.form.is_paid === 1 && !this.form.amount) this.form.amount = String(p.price)
      }
    },
    onPaytypeChange() {},
    onAmountInput() {
      // 仅数字校验提示，金额以实填为准
    },
    onProvinceChange() {
      this.form.city = ''
    },
    onVoucherSuccess(res, file) {
      if (res && res.data && res.data.url) {
        this.form.voucher = res.data.url
        this.$message.success('凭证上传成功')
      } else {
        this.$message.error('凭证上传失败')
      }
    },
    doSubmit() {
      if (this.loading) return
      // 整体校验
      let valid = true
      this.$refs.form.validate(v => { if (!v) valid = false })
      this.$refs.form2.validate(v => { if (!v) valid = false })
      if (this.form.is_paid === 1) {
        this.$refs.form3.validate(v => { if (!v) valid = false })
      }
      if (!valid) return
      if (this.priceError) {
        this.$message.error(this.priceError)
        return
      }
      if (this.isCompany && !this.form.staff_id) {
        this.$message.error('请选择归属销售')
        return
      }
      if (this.form.is_paid === 1 && !(parseFloat(this.form.amount) > 0)) {
        this.$message.error('已收款，请填写收款金额')
        return
      }

      this.loading = true
      orderAdd({
        lead_id: this.leadId,
        liang_account: this.form.liang_account.trim(),
        customer_name: this.form.customer_name.trim(),
        customer_phone: this.form.customer_phone.trim(),
        id_card: (this.form.id_card || '').trim(),
        product_id: this.form.product_id,
        price: this.form.price,
        paytype_id: this.form.paytype_id,
        province: this.form.province,
        city: this.form.city,
        district: (this.form.district || '').trim(),
        remark: (this.form.remark || '').trim(),
        staff_id: this.form.staff_id || 0,
        // 首次收款
        is_paid: this.form.is_paid,
        amount: this.form.is_paid === 1 ? this.form.amount : 0,
        paytime: this.form.is_paid === 1 ? (this.form.paytime || '') : '',
        voucher: this.form.is_paid === 1 ? this.form.voucher : '',
        transaction_id: this.form.is_paid === 1 ? (this.form.transaction_id || '').trim() : '',
        bill_remark: this.form.is_paid === 1 ? (this.form.bill_remark || '').trim() : ''
      })
        .then(data => {
          this.$message.success('创建成功')
          setTimeout(() => {
            this.$router.push('/order/list')
          }, 800)
        })
        .catch(() => {})
        .finally(() => { this.loading = false })
    }
  }
}
</script>

<style scoped>
.order-add-page {
  max-width: 720px;
  margin: 0 auto;
}

.form-card {
  border-radius: 10px;
  border: 1px solid #E5E9F2;
  padding: 8px 0;
}

.form-section {
  padding: 0 24px 16px;
  border-bottom: 1px solid #F2F4F8;
}

.form-section:last-child { border-bottom: none; }

.form-title {
  font-size: 15px;
  font-weight: 700;
  color: #18233C;
  padding: 18px 0 14px;
  display: flex;
  align-items: center;
}

.form-title::before {
  content: '';
  display: inline-block;
  width: 4px;
  height: 14px;
  border-radius: 4px;
  background: linear-gradient(180deg, #3668FC, #5B8DFF);
  margin-right: 10px;
}

.lead-tip {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #EDF3FE;
  border-radius: 8px;
  padding: 10px 14px;
  margin-bottom: 12px;
  font-size: 12px;
  color: #3668FC;
}

.lead-tip-icon { font-size: 14px; }

.form-hint {
  margin-top: 6px;
  font-size: 12px;
  color: #8A94AD;
}

.form-hint-err { color: #E5484D; }

.area-row {
  display: flex;
  gap: 12px;
}

/* 收款凭证上传 */
.voucher-uploader {
  width: 100%;
}

.voucher-uploader :deep(.el-upload) {
  width: 120px;
  height: 120px;
  border: 1px dashed #C3CADB;
  border-radius: 8px;
  cursor: pointer;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #FAFBFF;
  transition: border-color 0.2s;
}

.voucher-uploader :deep(.el-upload:hover) {
  border-color: #3668FC;
}

.voucher-uploader-icon {
  font-size: 26px;
  color: #8A94AD;
}

.voucher-preview {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 20px 24px;
}

/* ===== Element UI 品牌色统一 ===== */
::v-deep .el-button--primary {
  background: #3668FC;
  border-color: #3668FC;
}

::v-deep .el-button--primary:hover,
::v-deep .el-button--primary:focus { background: #5B8DFF; border-color: #5B8DFF; }

::v-deep .el-card {
  border-radius: 12px;
}
</style>